var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.51,
    height: 20.507,
    viewBox: "0 0 20.51 20.507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M15.051,13.259a8.332,8.332,0,1,0-1.791,1.792h0a1.5,1.5,0,0,0,.126.147l4.935,4.935a1.282,1.282,0,0,0,1.814-1.812L15.2,13.386a1.291,1.291,0,0,0-.147-.128Zm.331-4.927a7.05,7.05,0,1,1-7.05-7.05,7.05,7.05,0,0,1,7.05,7.05Z",
    transform: "translate(0.001 -0.002)",
    fill: "#7e7e7e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9263f98cb31c2a23aa7afbe6e4a47638.svg";
export { ForwardRef as ReactComponent };